import Image from 'next/image';
export default function Thumbnail(props) {
    return (
        <>
            <div className="flex flex-col gap-y-2 justify-center items-center animate-pulse">
                <a href={props.id === "UCvjNdLLy5sinqD92Axk8w-g" ? "https://twitch.tv/filian" : props.href} rel="noreferrer" target="_blank" className="relative w-auto overflow-hidden">
                    <Image width="128" height="128" referrerPolicy="no-referrer" alt="Avatar" className="object-cover rounded-xl h-24 w-24" src={"/unloaded.png"} unoptimized />
                </a>
                <div className="flex flex-col text-center justify-center items-center gap-y-3 pt-1">
                    <div className="h-4 w-12 bg-gray-500 rounded-xl" /> 
                    <div className="h-3 w-24 bg-gray-500 rounded-xl" /> 
                </div>
            </div>
        </>
    )
};